import React from "react";
import { cx } from "styled-system/css";
import { container, input, label } from "./checkbox.styles";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label: labelText, className, ...props }, ref) => {
    const checkboxInput = (
      <input type="checkbox" ref={ref} className={cx(input, className)} {...props} />
    );

    if (!labelText) {
      return checkboxInput;
    }

    return (
      <label className={container}>
        {checkboxInput}
        <span className={label}>{labelText}</span>
      </label>
    );
  },
);

Checkbox.displayName = "Checkbox";
